import { AttachableController } from '../../DOM/AttachableController';
import { TOUR_HINT_WRAPPER_ID } from './TourHintWrapper';
import { DOMUtils } from '../../DOM/DOMUtils';
import { innerPositionElement } from '../../DOM/utils';

export class TourHintController extends AttachableController {
  CLICK_CLASS: string = 'introHintClick';
  CLICK_DURATION: number = 1000;
  MOVE_SPEED: number = 350;
  onReposition: Function;
  //private readonly fadeTimeInMs: number = 250;

  constructor(private readonly domUtils: DOMUtils) {
    super();
    this.element = document.querySelector<HTMLElement>(
      `#${TOUR_HINT_WRAPPER_ID}`,
    );
  }

  show(/*time = this.fadeTimeInMs*/) {
    this.domUtils.showHint();
  }

  hide(/*time = this.fadeTimeInMs*/) {
    this.domUtils.hideHint();
    // this.hintElement.fadeOut(time);
    // this.hintElement.css(
    //   'transition',
    //   'left 0s ease-in-out, top 0s ease-in-out',
    // );
    // this.hintElement.offset({ left: -1000, top: 1000 });
  }

  async positionElement(
    element: HTMLElement,
    target: HTMLElement,
    positionX,
    positionY,
    offsetX,
    offsetY,
    minY,
  ) {
    await innerPositionElement(
      element,
      target,
      positionX,
      positionY,
      this.MOVE_SPEED,
    );
  }

  destroy() {
    this.hide();
    this.detach();
  }

  async simulateClick() {
    this.domUtils.clickHint(true);
    return new Promise<void>((res) => {
      setTimeout(() => {
        this.domUtils.clickHint(false);
        res();
      }, this.CLICK_DURATION);
    });
  }
}
